import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import I18n from 'i18n.js.erb'

const RejectingModal = ({
   itemToReject,
   setItemToReject,
   rejectingCauses,
   rejectingCause,
   handleRejectingCause,
   otherRejectingCause,
   handleSetOtherRejectingCause,
   handleReject,
   global,
   rejectConfirmMessage
  }) => {

  const [ hideRejectingOptions, setHideRejectingOptions ] = useState(true)

  return <Modal
    size="lg"
    show={ itemToReject !== null }
    onHide={() => {
      setItemToReject(null);
      setHideRejectingOptions(true)
    }}
    animation={false}
    centered
  >
    <Modal.Header>
      {
        hideRejectingOptions ?
          <Modal.Title>{I18n.t('js.modalRejecting.title')}</Modal.Title>
          :
          <Modal.Title>{I18n.t('js.modalRejecting.confirmUserTitle')}</Modal.Title>

      }

    </Modal.Header>
    <Modal.Body>
      {
        hideRejectingOptions ?
          <React.Fragment>
            <div className="row ml-3 mr-3">
              {
                rejectingCauses.map((cause) => {
                  return<span key={cause.key} className="col-xs-12 col-md-6">
                    <input type="radio"
                           value={cause.key}
                           checked={cause.key === rejectingCause}
                           id={"cause_" + cause.key}
                           className="ml-5 aiG-radio custom-control-input"
                           onChange={ (e) => handleRejectingCause(e.target.value) }
                    />
                    <label id={"label_cause_" + cause.key} className="pr-3 ml-1 aiG-label-radio custom-control-label" htmlFor={"cause_" + cause.key}>
                      <p className="text-weight-500">{(itemToReject === 'all' || global === true) ? I18n.t(cause.locale_p) : I18n.t(cause.locale_s)}</p>
                    </label>
                  </span>
                })
              }
            </div>
            <div className="row ml-3 mr-3 mt-3">
              <div className="col-12 p-0">
                <p className="text-weight-500">{I18n.t('js.modalRejecting.other')}</p>
                <textarea
                  className="form-control"
                  value={otherRejectingCause}
                  onChange={(e) => handleSetOtherRejectingCause(e.target.value) }
                  placeholder={I18n.t('js.modalRejecting.inputTextPlaceholder')}
                />
              </div>
            </div>
          </React.Fragment>
          :
          <React.Fragment>
          {
            rejectConfirmMessage
          }
          </React.Fragment>
      }
    </Modal.Body>
    <Modal.Footer>
      {
        hideRejectingOptions ?
          <React.Fragment>
            <button
              type="button"
              className="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized"
              onClick={() => setItemToReject(null)}
            >
              {I18n.t('js.common.button.cancel').toUpperCase()}
            </button>
            <button
              type="button"
              className="btn-standard bg-aig-gradient text-light br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px"
              onClick={()=>setHideRejectingOptions(false)}
              disabled={!rejectingCause && (!otherRejectingCause || otherRejectingCause === "")}
            >
              {I18n.t('js.common.button.confirm').toUpperCase()}
            </button>
          </React.Fragment>

        :
          <React.Fragment>
            <button
              type="button"
              className="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized"
              onClick={() => setHideRejectingOptions(true)}
            >
              {I18n.t('js.common.button.cancel').toUpperCase()}
            </button>
            <button
              type="button"
              className="btn-standard bg-aig-gradient text-light br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px"
              onClick={() => {
                handleReject();
                setHideRejectingOptions(true)
              }}
              disabled={!rejectingCause && (!otherRejectingCause || otherRejectingCause === "")}
            >
              {I18n.t('js.common.button.confirm').toUpperCase()}
            </button>
          </React.Fragment>
      }
    </Modal.Footer>
  </Modal>
};

export default RejectingModal;